module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 1")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2 years later"), _c('br'), _vm._v(" Key West")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("B")])]), _vm._v("efore him, frond coral waved in a slow and majestic dance, and a small ray emerged from the sand by the reef, weaving in a swift escape, aware that a large presence, possibly predatory, was near.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean O’Hara shot back up to the surface, pleased with his quick inspection of Pirate Cut, a shallow reef where divers and snorkelers alike came to enjoy the simple beauty of nature. It was throughout history a place where many a ship had met her doom, crushed by the merciless winds of a storm. Now only scattered remnants of that history remained; salvage divers of old had done their work along with the sea, salt and the constant shift of sands and tides and weather that remained just as turbulent through the centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was still, he decided, a great place to film.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("He hadn’t opted for scuba gear that day—it had been just a quick trip, thirty minutes out and thirty back in, early morning, just to report to his partner, David ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Beckett, so they could talk about their ever-changing script and their plans for their documentary film.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Because Sean was an expert diver, he seldom went diving alone. Good friends—some of the best and most experienced divers in the world—had died needlessly by diving alone. But a free dive on a calm day hadn’t seemed much of a risk, and he was pleased that he had taken off early in the morning. Most of the dive boats headed out by nine, but few of them came to Pirate Cut as a first dive, and it wouldn’t get busy until later in the day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And out in the boat, he wasn’t exactly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bartholomew was with him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Climbing up the dive ladder at the rear of his boat, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conch Fritter,")]), _vm._v(" he tossed his flippers up and hauled himself on board. His cell phone sat on his towel, and the message light was blinking. Caller ID showed him that he’d been called from O’Hara’s, his uncle’s bar.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I thought about answering it, but refrained.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean turned at the sound of the voice. Bartholomew was seated at the helm of the dive boat, feet in buckle shoes up on the wheel, a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("National Geographic")]), _vm._v(" magazine in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bartholomew was getting damned good at holding things.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Thank you for refraining. And tell me again, why the hell are you with me? You hate the water,” Sean said, irritated. He pushed buttons on his phone to receive his messages, staring at Bartholomew.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Love boats, though,” Bartholomew said.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Sean groaned inwardly. It was amazing—once he hadn’t believed in Bartholomew. Actually, he’d thought ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("the ghost might have been one of his sister Katie’s imaginary friends. He realized he either had to accept that she was crazy or that there was a ghost. At that time, Sean couldn’t see or hear Bartholomew.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("But that had been a while ago now. While solving the Effigy Murders—as the press wound up calling them—he’d ended up with his head in a bandage and stitches in his scalp.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was the day the damned stitches had come out that he’d first seen the ghost—as clearly as if he had physical substance—sitting in a chair next to the hospital bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean listened to his messages. The first, from David Beckett, asking him what time he wanted to go out. Sean grinned. David was in love—and sleeping late. Sean was glad, since it seemed that his old friend was in love with his sister, Katie, and she was in love with him. They’d both seen some tough times, and Sean was happy for them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The next message was from his uncle just asking him to call back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He did so. Still, he didn’t learn much. His uncle just wanted him to come to the bar. Sean told him it would take him about forty-five minutes, and Jamie said that was fine, just to come.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So what’s up?” Bartholomew asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Going to the bar, that’s all,” Sean said. He was curious. Jamie wasn’t usually secretive.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Can you keep a hand on the helm? Bring her straight in?” Sean asked Bartholomew as he brought up the anchor. Securing it, he added, “Jeez, am I crazy asking you that?”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Bartholomew looked at him with tremendous indignation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Really! That was absolutely—churlish of you! If there’s one thing I know, it’s a lazy man’s boat like this!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean grinned. “I’ll be in the head in the shower for about fifteen minutes. That’s all you need to manage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’ll be great if we pass the Coast Guard or a tour boat!” Bartholomew cried.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean ignored him. He just wanted to rinse off the sea salt—his uncle had him curious.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He showered, dried and dressed in the head and cabin well within his fifteen minutes. In another twenty, he was tying up at the pier.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Duval Street was quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As he walked from the docks to O’Hara’s, Sean mused with a certain wry humor that Key West was, beyond a doubt, a place for night owls. He was accustomed enough to working at night—or even partying at night—but he was actually more fond of the morning hours.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you think Jamie wants?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean heard the question again—for what seemed like the tenth time now—and groaned inwardly without turning to look at the speaker. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Imagine, once he had")]), _vm._v(" wanted "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to see the damned ghost!")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Oh, he could see Bartholomew way too clearly now, though when he had first come home to Key West—hearing that David Beckett was in town and worried for his sister’s safety—he had come with his longtime fear for Katie’s mind. She had always seemed to sense or see things. But that had been Katie, not him.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Bartholomew had apparently wanted to be known, though at first he proved his presence by moving things around.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then Sean had seen him in that damned chair in the hospital room. Now he could see the long-dead privateer as easily as he could see any flesh-and-blood, living person who walked into his life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He cursed the fact.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He had never believed in ghosts. He’d never wanted to believe. In fact, he’d warned Katie not to ever talk about the fact that she had “strange encounters” or had been “gifted” or “cursed” from a young age. The majority of the world would think that she should be institutionalized.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He wasn’t pleased that he saw Bartholomew. Now he had the fear that he would one day wind up institutionalized himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And he was far from pleased that the dapper centuries-old entity had now decided to affix himself to Sean.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I will not answer you. I will never answer you in public,” Sean said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bartholomew laughed. “You just answered me. Then again, we’re hardly in public, you know. I think the whole island is still asleep. Besides, you’re a filmmaker. An ‘artiste!’ People will happily believe that you are eccentric, and it’s your brilliance causing you to speak to yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Right. Don’t you feel that you should go and haunt my sister?” Sean asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I believe she’s busy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m busy,” Sean said.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Look, I’m apparently hanging around for something,” Bartholomew said. “Others have gone on, and I haven’t. You seem to be someone I must help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t need help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You will, I’m sure of it,” Bartholomew said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean kept walking.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So what do you think he wanted?” Bartholomew persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know,” Sean said flatly. “But he wanted something, and that’s why I’m going to see him.” He cast a glance Bartholomew’s way. The privateer—hanged long ago for a deed he hadn’t committed—was really quite a sight. His frock coat and stockings, buckle shoes, vest and tricornered hat all fit his tall, lean physique quite well. In his lifetime, Sean thought dryly, he had probably made a few hearts flutter. Sadly, he had died because of the death of the love of his life, and an act of piracy blamed upon him. However, after haunting the island since then, he had recently found a new love, the “lady in white,” legendary in Key West. When they filmed their documentary, Sean meant to make sure that he covered Bartholomew’s case and those of his old and new loves.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He’d heard once that ghosts remained on earth for a reason. They wanted to avenge their unjust deaths, they needed to help an ancestor or they were searching for truth. There were supposedly ghosts who were caught in time, reenacting the last moments of their lives. But that was considered “residual haunting,” while Bartholomew’s determination to remain on earth in a spectral form was known as “active” or “intelligent” haunting.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("Bartholomew had been around for a reason—he had ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("been unjustly killed. But Sean couldn’t figure out why he remained now. His past had been aligned with David Beckett and his family, and Sean had to admit that Bartholomew had been helpful in solving the Effigy Murders, all connected to the Becketts.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Maybe he had stayed because of the injustice done to him and because he still felt that he owed something to the Becketts. All Sean knew was that he had been Katie’s ghost—if there was such a thing—and now he seemed to be with him all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean liked Bartholomew. He had a great deal of wit and he knew his history. He was loyal and might well have contributed to saving their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But it was unnerving from the get-go to realize that you were seeing a ghost. It was worse realizing that the ghost was no longer determined to stick to Katie like glue, but had moved on to him. He was a good conversationalist—and thus the problem. Sean was far too tempted to talk to him, reply in public and definitely appear stark, raving mad upon occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ghosts were all over the place, Bartholomew had informed him. Most people felt a whisper in the breeze, sometimes a little pang of sorrow, and if the ghost was “intelligent” and “active,” it might enjoy a bit of fun now and then, creating a breeze, causing a bang in the dark of night, and so on. Katie had real vision for the souls lurking this side of the veil. So far, thank God, he’d seen only Bartholomew, and maybe a mist of others in the shadows now and then.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean had been damned happy before he’d “seen” a ghost at all.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("Pirate Cut, he noted mentally. A good place to begin ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("shooting. They hadn’t known in Bartholomew’s day that the reefs needed to be protected. They had brought their ships to the deep-water plunge just off the reef many times. Bartholomew knew for a fact that the legend about the area was true—ships of many nations had foundered here in storms, been cut up on the reefs and left to the destruction of time and the elements. But there was treasure scattered here, treasure and history, even if it had been picked over in the many years since.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("It would also make for beautiful underwater footage. The colors were brilliant; the light was excellent. And it was near the area where Bartholomew had allegedly chased and gunned down a ship and murdered those aboard. Falsely accused, in the days after David Porter’s Pirate Squadron had been established, he had been hanged quickly, and it had been only after his unjust death that his innocence had been proven.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was a good story for a documentary. Especially considering the events of the recent past, when a madman had decided that it was his ancestor who had been wronged and that the Becketts were to pay.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The whole story needed to be told, and it would.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And perhaps, if he managed to get Bartholomew’s story out there, with any luck Bartholomew might “see the light” and move on to the better world he believed he would find.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was true that Bartholomew was not a bad guy and that, if he were flesh and blood, he’d be great to hang out with. But with Katie engaged to David Beckett now and basically living at the Beckett house, it seemed that Bartholomew was really all his.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("And no way out of it—it was awkward. Disconcerting. ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("And he was starting to look as if he walked around talking to himself. So much for an intelligent and manly image, Sean thought dryly.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Bartholomew, please, stop talking to me. You’re well aware that I look crazy as all hell when people see me talking to you, right?” Sean demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I keep telling you, you’re an artist. And a true conch,” Bartholomew said. “Born and bred on the island. Tall, with that great red hair, good and bronzed—hey, fellow, a man’s man as they say,” Bartholomew told him, waving a ringed hand in the air. “Trust me—you’re masculine, virile, beloved and—an artist. You’re allowed to be crazy. And, good God, man—this is Key West!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Right. Then the tourists will have me arrested,” Sean said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They’d reached O’Hara’s, toward the southern end of Duval. Sean cast Bartholomew a warning glare. Bartholomew shrugged and followed Sean in.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean walked straight up to the bar. Jamie O’Hara himself was working his taps that day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hey, what’s up?” Sean asked, setting his hands on the bar and looking at Jamie, who was busy drying a beer glass.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("It was early in the day—by Key West bar standards. Just after eleven. Jamie, when he was in town, usually opened the place around eleven-thirty, and whoever of his old friends, locals, or even tourists who wandered in for lunch early were served by Jamie himself. He cooked, bussed and made his drinks, poured his own Guinnesses—seven minutes to properly fill a Guinness glass—and he did so because he liked being a pub owner and he was the kind of employer who liked people, his ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("employees and his establishment. He could handle the place in the early hour—unless there was a festival in town. Which, quite often, there was. Starting at the end of this week, he’d have double shifts going on—Pirates in Paradise was coming to town.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("At this moment, though, O’Hara’s was quiet. Just Jamie, behind the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jamie was the perfect Irish barkeep—though he had been born in Key West. He, like Sean’s dad, had spent a great deal of time in the “old country” visiting their mother’s family—O’Casey folk—and he and Sean’s dad had both gone to college in Dublin. Jamie could put on a great brogue when he chose, but he could also slip into a laid-back Keys Southern drawl. Sean had always thought he should have been an actor. Jamie said that owning a pub was nearly the same thing. He had a rich head full of gray hair, a weather-worn but distinguished face, bright blue eyes and a fine-trimmed beard and mustache, both in that steel-gray that seemed to make him appear to be some kind of clan chieftain, or an old "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ard-ri,")]), _vm._v(" high king, of Ireland. He was well over six feet, with broad shoulders and a seaman’s muscles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jamie indicated the last booth in the bar area of the pub, which was now cast in shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He realized that someone was sitting in the booth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He couldn’t help but grin at his uncle. “You’re harboring a spy? A double agent? Someone from the CIA working the Keys connection?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean knew that bad things—very bad things—could happen, even in Key West, Florida, “island paradise” though it might be. He’d seen them. But someone hiding in the shadows seemed a bit out of the ordinary.")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Jamie shrugged and spoke softly. “Who knows why she’s sitting in the dark? She’s a nice kid. Came in here, I guess, ’cause the world seems to consider it neutral ground or something. She heard about you and David and the documentary you two are going to film together.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean frowned. “We’ve had ads in the papers for crews for the boats and the filming. David and I have been setting up for interviews at his place.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you want from me, son, eh? She came in here, knowing I was related to the O’Hara looking to film about Key West and her mysteries. I said yes, and she asked if there was any way she could speak to you alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She’s applying for a job? Then she should go about it just like all the others and ask for an interview,” Sean said, annoyed. He couldn’t really see the woman in the corner, but he thought she seemed young. Maybe she was trying to secure a position by coming through the back door, flirting, drawing on his uncle’s sympathies.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t think that it’s work she’s looking for, but I don’t know. She’s pretty tense. She wanted to know about the recent business down here—you know, all the nasty stuff with the murders—and she was mainly wanting to know, so it seemed, how you all coped with the bad things going on. Like, frankly, were you a pack of cowards, was it really all solved by the police, did I think that you were capable people—and did you really know the area.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, great. She sounds like someone I really want to hire!” Sean said.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("Jamie laughed. “She’s not that bad—she was dead ")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("honest in the questions she asked me. She didn’t use the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("coward,")]), _vm._v(" that was mine. There’s something I like about her, Sean. Talk to her. She seems tense and nervous—and somehow, the real deal.” His uncle leaned closer to him. “There’s some mystery about this girl, and yet something real. Talk to her. Oh, and by the way, she is really something. She’s got every diving certificate, advanced, teacher, you name it. She’s gotten awards for her writing, and oh—hmm. She happens to have amazing blond hair, giant blue eyes and a shape to die for, nephew. Check it out. Go ahead. What’s the matter, boy, scared?”")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("Sean looked at his uncle in surprise and laughed. Scared? No. He was at least intrigued. Couldn’t hurt to talk to the woman. He and David were anxious to get started on their project because it was important to both of them—and it was also what they were best known for in their separate careers. But they were discussing just what bits and pieces and stories they would use for their documentary. Bartholomew’s situation was a must, Robert the Doll was a must, and the bizarre, true and fairly recent history of Elena and Count von Cosel was also a must. It wouldn’t be Key West if they didn’t touch on Hemingway and the writing connection. And there had to be pirates, wreckers, sponge divers and cigar makers, and how the Conch Republic became the Conch Republic. But as to exactly what they were using and what they were concentrating on, they were still open. They hadn’t made any hard-and-fast decisions yet, but since David was home and planning a wedding with Sean’s sister, they had decided that, at long last, they should work together. Friends in school who ")]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("hadn’t seen each other in a decade, they had both gone the same route—film. Once the tension and terror of a murderer at work in Key West had died down, David had decided he was going to stay home awhile. That had a lot to do with the fact that he was in love with Sean’s sister, Katie O’Hara. But David was a conch, too—born and bred in Key West from nearly two generations of conchs. David belonged here.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Sean had stayed away from home a lot, too. But now he was excited about the idea of working with David—and working on a history about Key West and the surrounding area, bringing to light what truth they could discover that lay behind many of the legends. One thing had never been more true—fact was far stranger than fiction. But as he knew from living here, fact could become distorted. Tourists often asked which form of a story told by a tour guide was the true one. He and David meant to explore many of the legends regarding Key West—and, through historical documents, letters and newspapers of each era, get to the heart of the truth. Fascinating work. He loved his home. Key West was the tail end of Florida, an oddity in time and place. An island accessible only by boat for much of its history. Southern in the Civil War by state, Union by military presence.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bartholomew suddenly let out a soft, low whistle, almost making Sean jump. He gritted his teeth and refused to look at the ghost.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Pretty, pretty thing!” Bartholomew said. “I’d have been over there by now, not wondering if there was some secret agenda behind it all!”")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Somehow, Sean refrained from replying. He even kept smiling and staring straight at his uncle.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Are you going to stare at the shadows? Or are you at least going to let the girl have her say?” Jamie demanded. “I’ll bring coffee,” he added.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know where the coffee is, thanks, Uncle,” Sean said. He came behind the bar to pour himself a cup, trying to get a better look at the woman at the booth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was waiting for him. There was no looking at her surreptitiously—she was staring back at him. She was still in the shadows, but his uncle seemed to be right about one thing—she was stunning. She had the kind of cheekbones that were pure, classic beauty—at eighty, she’d still be attractive with that bone structure. Her hair was golden and pale and simply long, with slightly rakish and overgrown bangs. He didn’t think she spent a lot of money in a boutique salon; the shades of color had come from the sun and the overgrown, rakish look was probably because she didn’t spend much time getting it cut.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was dressed more like a native than a tourist—light cotton dress with a little sweater over her shoulders. Down here, the days were often hot, tempered only by the ocean and gulf breezes that were usually present. But inside, it could be like the new ice age had come—because of the heat, businesses were often freezing. Jamie kept his swinging doors to the outside open sometimes—it was a Key thing. Trying to be somewhat conservative in the waste of energy, the air blasted in the back, not near the front.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("Coffee in hand, he walked back to the booth at last. “Hi. I’m Sean O’Hara. We’re doing interviews tomorrow ")]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("and the next day at the old Beckett house, because, I’m assuming you know, it’s a joint project between David Beckett and myself.” He offered her his hand.")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She accepted it. Her grip was firm. Her palms were slightly callused, but they were nice, tanned. Her fingers were long and she had neat nails, clipped at a reasonable length rather than grown out long.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Her eyes were steady on his.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m Vanessa Loren,” she said. “I have real experience and sound credentials, but that’s not exactly why I’m here, or why I wanted to meet with you here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He shrugged, taking a seat opposite her in the booth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She suddenly lifted both hands and let them fall. “I’ve actually practiced this many times, but I’m not sure where to begin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’ve—practiced?” Sean asked. “Practiced an interview for a job?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She nodded. “I’ve practiced trying to explain. This is really important to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right. Start anywhere,” Sean said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She lowered her head, breathing in deeply. Then she looked at him again. “Unless you’ve been under a rock, you must have heard about the Haunt Island murders.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He blinked and tried to remember. He’d been filming in the Black Sea two years ago, but he had heard about the bizarre murders. Members of a film crew had been gruesomely slain on an island just southwest of South Bimini. Though uninhabited, the island belonged to the Bahamas.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("He hadn’t moved into the booth and hadn’t left room ")]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("for Bartholomew. However, the ghost had followed him to the booth, and leaned against the wall just across from them.")])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, I heard something about the murders,” he said carefully.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I was with the film crew,” she said. “One of my best childhood friends was the director, and I was the scriptwriter. We both put money into the venture, and we were doing double duty. When I say low budget, I mean low budget. But we had it together—we knew what we were doing, and we worked incredibly hard. The film wasn’t going to win an Oscar, but we had hopes of having it picked up by a national distributor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Don’t know much about that,” Bartholomew said sorrowfully, as if he were part of the conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You were making a film, and people were brutally killed,” Sean said, ignoring Bartholomew. He didn’t want to feel sympathy for her. Sadly, there were a number of unsolved mysteries that had little chance of being solved. He vaguely remembered some of the newspaper articles his sister had e-mailed him at the time—a lot of people were chalking the tragedy up to the mystery of the Bermuda Triangle. “What are you trying to tell me, or ask me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She took a deep breath. “It’s really all the same area—the same area you’re doing a documentary on. Do you know how many boaters go from the Intracoastal, South Florida, say Fort Lauderdale and Miami, out to Bimini and then on to Key West?” she asked. “Or vice versa. We’re all connected here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know that,” he said, feeling oddly irritated. “We always intended to do a documentary on the area.”")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“This is a story that shouldn’t just be included, it should be the main focus,” she said somberly. “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Because it’s an unsolved mystery. And there’s a killer or killers out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sadly, there are many killers on the loose at any given time. I’m not sure what we can do for you. David and I are not law enforcement,” Sean said. “And if we were, Haunt Island is still the Bahamas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It doesn’t sound as if law enforcement has had much luck yet,” Bartholomew interjected.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I was there when it happened,” she said quietly. “The truth must be discovered.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But we’re just doing a documentary,” Sean protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re doing a documentary on history—and oddities and mysteries. You’ll never find a better mystery,” she said flatly. “I admit, the script was written for what would basically be a teenage-slasher-type flick,” she said. “But it was based on history. Key West and Bahamian history.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He shook his head. “All right, I’m still getting lost here. You were filming a movie based on history, but it was a slasher film? Low budget? A historical slasher film? You’re talking big money there.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("She shook her head. “Not with the people we had working with us. The new digital age has helped a hell of a lot. And we had easy access to costumes—we bought most of them here, some from the shop on Front Street, and some at Pirates in Paradise. We refitted one of our boats, and with a little digital finesse, we had a pirate ship, which could become pirate ships. We knew what ")]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("we were doing—I’m talking about people with real degrees in film and real experience—and more. It was our project.”")])]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m listening. Tell me more.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re from here and you’re working on history,” she said. “You must have heard of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Geneva")]), _vm._v("—and Mad Miller and his consort, Kitty Cutlass, and the murder of Dona Isabella.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He nodded slowly. He knew the legend. All Key West kids knew the stories about pirates in the area. They made great tales at campfires. “A piece of pirate lore,” he said.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("“Yes, and if you’re following pirate lore, you should be following that story. It was past the Golden Age of Piracy. It was after David Porter came here to clear out the pirates. There were still Spaniards living here, naturally. Dona Isabella was a wealthy woman, with homes in Madrid and Key West. She was married to Diego, a very wealthy Spanish merchant. She was kidnapped off a Spanish ship, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Geneva.")]), _vm._v(" They say she was never ransomed because Mad Miller, the pirate, fell in love with her—and because of that, she wound up dead. Some say that Mad Miller murdered her in a frenzy, because she loathed him. Some say that Kitty Cutlass, furious over her lover’s adoration for another woman, was the one to kill her. At any rate, she supposedly wound up dead in the company of the pirates. It’s thought that she survived until the pirates reached Haunt Island, where they might have drawn in for ship repairs. Some of Mad Miller’s men then massacred the remaining crew members of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Geneva,")]), _vm._v(" and members of their own ")]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("crew who were in revolt over what had happened. Thus the name, obviously, Haunt Island, and the legend.”")])]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I still don’t see—” Sean began.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dona Isabella lived in Key West. Her ship, a Spanish ship, left from Key West. The pirates raided her in American waters. Off of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Key West.")]), _vm._v(" Mad Miller came from Key West. Let’s see—Kitty Cutlass began as a prostitute in a shack on Duval. Mr. O’Hara, this is an amazing story that has everything to do with the documentary you want to film. You’re a fool if you haven’t already thought of using the legend—and the truth of what happened to the members of our film crew,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All right—that was aggravating. But there was something desperate in her voice that kept him from entirely losing his temper.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Okay, Miss Loren. You have a good story. What, exactly, is it that you want? I’ve told you, we’re not any form of law enforcement. I can’t go over to the Bahamas and just solve your mystery for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She inhaled again, staring at him. She let out a long breath of air. She seemed to physically square her shoulders, as if seeking strength and resolve.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know that, and…” She paused, wincing. “Look, I’m sorry. I’m just passionate about my feelings on this. First, I need you to hire me. I’m good—really good. I swear. You can check all my references,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I would definitely do so, no matter what,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’d bet good money that she has excellent references,” Bartholomew said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean locked his jaw, determined not to turn, or respond to the ghost in any way.")])]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“No one is hired unless David and I agree,” he said to Vanessa.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That is certainly understandable,” she said. Again, she paused. “I know all about David Beckett, as well. I know that he was once accused of murder, and I know how desperate he was to find the truth. And the truth was discovered. I can’t believe that he wouldn’t understand how I feel, or be sympathetic to my cause.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean felt tension steal through his body. The Effigy Murders had been bad, very bad. He still felt they were all recovering from the terrible things that had happened. He still had scars beneath his hairline.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("David would be sympathetic, he knew.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Go on,” he said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then—I think you need to make me your assistant. I’m excellent at managing a schedule, and I can write a scene, narrative, interview questions, anything you need, at the drop of a hat. I know you do a lot of your own scheduling and writing. That’s why I say "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("assistant.")]), _vm._v(" I went to film school. When needed, I can handle any kind of a camera. I’m fit so I can tote and carry. The filmmaker in you must see what there is here—a legend that remains a mystery, historical and contemporary. You can look for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Geneva,")]), _vm._v(" you can really follow the path of those who came before you. And if you leave out piracy, and the stamping out of the pirates, and the supposed massacre on Haunt Island, you’re doing a disservice to everyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He leaned back. “If this is such a great documentary, why don’t you do it yourself?” he demanded.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v("She leaned back, biting her lower lip. “Well, for ")]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_vm._v("one, I don’t have the kind of money you need for a documentary. And…”")])]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She leaned forward. “Look, I’ll work cheap. I’ll work harder than anyone you ever imagined.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He leaned back, shaking his head. “I’d like to help you, I’d really like to help you. But it seems as if you’re chasing something, and I’m not—I’m not what you’re looking for. If these murders haven’t been solved, you need a private investigator. You need—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Have you ever tried to look for a private investigator who specializes in water, legends and boats?” she asked irritably.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He hesitated for a moment. “Look, from what I understand, every agency possible was involved in that case. If there are no clues, there are no clues.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No one wanted to follow through on the legend—or the history,” she said, exasperated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He felt his fingers tense around his coffee cup and he stared at her. “You’re trying to tell me that pirates returned to massacre your friends?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Something about the tightening in her lips and the way that she stared at him caused him to feel as if he should be ashamed—as if he had spoken out of turn.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But he hadn’t. And he couldn’t explain to her that he knew what ghosts were capable of doing, and what they weren’t. As a matter of fact, he knew a few of them….")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s not what I’m suggesting at all,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then?”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_vm._v("“I—don’t know, exactly,” she said, looking away. “Here’s the thing. We’ve had this movie stowed since it happened. But…people know about it. I’m afraid we’ll ")]), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_vm._v("get an offer from a major distributor. My partner would gladly sell. I don’t want to sell—not unless I can get some justice for those who were involved. I don’t want to make money on sensationalism, on something…something unsolved. I’ve gotten Jay to agree that I can try one more time to discover the truth.”")])]), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Please. Please just tell me that you’ll consider doing it?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He stared at her, not knowing what to say.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No. A flat-out no would be a great answer. He and David hadn’t set anything in stone as yet, but…no. This one had to be a no. They both had their individual exemplary careers, they knew what they were doing. They could write themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m sorry. I just don’t think my partner will agree,” Sean said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Will you ask David Beckett?” she queried stubbornly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He smiled. “Will you quit asking if I talk to him and he says no?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She smiled. “You’re—Look, I know I’m asking a lot without much to offer. But I am really good at what I do, and if you give me a few weeks, I promise, I’ll help to make anything you want to do come out as brilliantly as possible. I’ll be slave labor, I swear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t want slave labor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll be the best damned assistant you’ve ever had,” she swore.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Take her up on it!” Bartholomew said. “Hell, my boy! Take her up on it just for the pleasure of having her upon your wretched little boat.”")])]), _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll talk to David,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You really will. And…and if he’s hesitant, if there’s any chance, will you let me try to persuade him, as well?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He forced an even smile. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No, just say no!")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He asked himself if he would be so torn, so tempted, if the person asking him wasn’t this young woman, not just beautiful, but…strong. So confident in her ability that she would swear she could make his work the best ever.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ability.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The way she looked.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The sound of her voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The mystery involved. Yes, he knew the damned legend. And hell yes, he was curious.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Look,” he began.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But she wasn’t looking at him. She was looking at the door. She let out a little cry of surprise and gladness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean swung around. His sister had just come in the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He looked at Vanessa Loren.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ah, hell.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Hell.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The young woman knew Katie. He should have figured.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He stared back at her, irritated, and suddenly certain that it was all over.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You know my sister,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She glanced at him while rising. “Yes, I know Katie. I’ve been on a few dive boats with her, and of course, I bring friends in here for Katie-okie when I’m down….”")])]), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She started to head out to see Katie. He set his fingers around her wrist, drawing her back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She didn’t jerk away, but then his hold was pretty firm. Those huge, cornflower-blue eyes of hers lit on him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He smiled coldly. “You know my uncle, too, don’t you? And my uncle knew just who you were and what you wanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve met Jamie before, yes,” she admitted. “Katie can explain it all to David, if you don’t want to, but I know that she’ll convince him that I’m right. I came to you first, because Katie told me that David had said all the major decisions were going to be yours, so if you just agree—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He stood, releasing her wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t like being played,” he said flatly. “Good day, Miss Loren.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She didn’t call after him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bartholomew did.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sean! Oh, come on, Sean. I can help you with this, I was around when it all happened,” the dapper buccaneer cried to him. “Sean, oh, do come on! If I were flesh and blood, I’d be on this like a mosquito at a topless bar! Sean!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sean passed Katie near the doorway. “Hey, sis,” he said, kissed her cheek, and kept on going.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They’d all just survived near death. They had dealt with total insanity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He would have to be insane himself to get into something like this again.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Mr. O’Hara!”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("She had followed him out. The lithe and dignified ")]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v("Miss Loren had come rushing out, and now she stood on the sidewalk, staring after him.")])]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Despite himself, he paused.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She walked to him, her chin high. “I never meant to play anyone,” she said. “I’m just desperate for help. You don’t understand,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I think I do,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, no, you don’t. I have reason to believe that someone must find out what happened, not just for those who were killed, but…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Other things have happened. Bad things. Not involved with filming, but with other boaters who disappeared near Haunt Island.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The sea can be huge and merciless, Miss Loren. And sadly, throughout history, many a boat and ship have disappeared without a trace.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“There’s more to it. I know there’s more to it, and I’m afraid.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Afraid of what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m afraid that if the truth isn’t discovered, more people will die. That there will be blood and death…a massacre again, and maybe this time, here, in Key West.”")])])]), _c('a', {
    attrs: {
      "id": "page56"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page56"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f81ad06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781488099151_ch01.vue
// module id = 75
// module chunks = 0